export const appDownloadConfig = {
  appName: 'Upzi',
  appStoreUrl:
    'https://apps.apple.com/vn/app/upzi-t%C3%ACm-vi%E1%BB%87c-l%C3%A0m-cho-gen-z/id6744628248',
  playStoreUrl:
    'https://play.google.com/store/apps/details?id=com.navigosgroup.upzi&referrer=utm_source%3DUpzi_landing_page', // Link tạm thời - thay bằng link Play Store thật sau
  qrCodeUrl: `/images/qr_code_landing_page.svg`,
  fallbackUrl: 'https://upzi.vn/tai-ung-dung', // URL fallback cho desktop
};
